import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { authServies } from "../../services/authServices";
import { logoutUser } from "../Auth/authSlice";
import { openErrorSnack, openSnackBar } from "../modals/snackBarSlice";

const initialState = {
  skills: [],
  total: 0,
  skill: {},
  pending: false,
};

export const getDevSkills = createAsyncThunk(
  "/skills/getDevSkills",
  async (params = null, { dispatch }) => {
    try {
      await authServies.http.get("/sanctum/csrf-cookie");
      const response = await authServies.http.get("/api/skills");
      console.log(response);
      return response;
    } catch (error) {
      if (error.response.status === 401) {
        dispatch(
          openErrorSnack({ message: "please sign in to perfom this action" })
        );
        dispatch(logoutUser());
      }
      if (error.response.status === 403) {
        dispatch(
          openErrorSnack({
            message: error.response.data.message,
          })
        );
      }
      if (error.response.status === 422) {
        dispatch(openErrorSnack({ message: error.response.data.message }));
        return error.response.data;
      }
      if (error.response.status === 429) {
        dispatch(
          openErrorSnack({
            message: ` ${error.response.data.message} , try after some seconds`,
          })
        );
        return error.response.data;
      }
      return error.response;
    }
  }
);

export const getDevSkill = createAsyncThunk(
  "/skills/getDevSkill",
  async (logs, { dispatch }) => {
    console.log(logs);
    try {
      await authServies.http.get("/sanctum/csrf-cookie");
      const response = await authServies.http.get(`/api/skills/${logs}`);
      if (response.status === 429) {
        return response.statusText;
      } else {
        return response.data.data;
      }
    } catch (error) {
      if (error.response.status === 401) {
        dispatch(
          openErrorSnack({ message: "please sign in to perfom this action" })
        );
        dispatch(logoutUser());
      }
      if (error.response.status === 403) {
        dispatch(
          openErrorSnack({
            message: error.response.data.message,
          })
        );
      }
      if (error.response.status === 422) {
        dispatch(openErrorSnack({ message: error.response.data.message }));
        return error.response.data;
      }
      if (error.response.status === 429) {
        dispatch(
          openErrorSnack({
            message: ` ${error.response.data.message} , try after some seconds`,
          })
        );
        return error.response.data;
      }
      return error.response;
    }
  }
);

export const addDesvSkill = createAsyncThunk(
  "/skills/addDesvSkill",
  async (logs, { dispatch }) => {
    console.log(logs);
    try {
      await authServies.http.get("/sanctum/csrf-cookie");
      const response = await authServies.http.post("/api/skills", logs);
      dispatch(getDevSkills());

      return response;
    } catch (error) {
      if (error.response.status === 401) {
        dispatch(
          openErrorSnack({ message: "please sign in to perfom this action" })
        );
        dispatch(logoutUser());
      }
      if (error.response.status === 403) {
        dispatch(
          openErrorSnack({
            message: error.response.data.message,
          })
        );
      }
      if (error.response.status === 422) {
        dispatch(openErrorSnack({ message: error.response.data.message }));
        return error.response.data;
      }
      if (error.response.status === 429) {
        dispatch(
          openErrorSnack({
            message: ` ${error.response.data.message} , try after some seconds`,
          })
        );

        return error.response.data;
      }
      if (error.response.status === 429) {
        dispatch(
          openErrorSnack({
            message: ` ${error.response.data.message} `,
          })
        );

        return error.response.data;
      }
      return error.response;
    }
  }
);

export const updateDevSkill = createAsyncThunk(
  "/skills/updateDevSkill",
  async (logs, { dispatch }) => {
    console.log(logs);
    try {
      await authServies.http.get("/sanctum/csrf-cookie");
      const response = await authServies.http.patch(
        `/api/skills/${logs.id}`,
        logs
      );
      dispatch(getDevSkills());
      return response;
    } catch (error) {
      if (error.response.status === 401) {
        dispatch(
          openErrorSnack({ message: "please sign in to perfom this action" })
        );
        dispatch(logoutUser());
      }
      if (error.response.status === 403) {
        dispatch(
          openErrorSnack({
            message: error.response.data.message,
          })
        );
      }
      if (error.response.status === 422) {
        dispatch(openErrorSnack({ message: error.response.data.message }));
        return error.response.data;
      }
      if (error.response.status === 429) {
        dispatch(
          openErrorSnack({
            message: ` ${error.response.data.message} , try after some seconds`,
          })
        );
        return error.response.data;
      }
      return error.response;
    }
  }
);

export const deleteDevSkill = createAsyncThunk(
  "/api/skills/",
  async (logs, { dispatch }) => {
    try {
      await authServies.http.get("/sanctum/csrf-cookie");
      const response = await authServies.http.delete(`/api/skills/${logs}`);
      console.log(response);
      dispatch(
        openSnackBar({
          message: "deleted successfully",
        })
      );
      return response;
    } catch (error) {
      if (error.response.status === 401) {
        dispatch(
          openErrorSnack({ message: "please sign in to perfom this action" })
        );
        dispatch(logoutUser());
      }
      if (error.response.status === 403) {
        dispatch(
          openErrorSnack({
            message: error.response.data.message,
          })
        );
      }
      if (error.response.status === 422) {
        dispatch(openErrorSnack({ message: error.response.data.message }));
        return error.response.data;
      }
      if (error.response.status === 429) {
        dispatch(
          openErrorSnack({
            message: ` ${error.response.data.message} , try after some seconds`,
          })
        );
        return error.response.data;
      }
      return error.response;
    }
  }
);

const skillSlice = createSlice({
  name: "skillSlice",
  initialState,
  reducers: {},
  extraReducers: {
    [getDevSkills.pending]: (state, action) => {
      state.pending = true;

      const result = action.payload;
      console.log(result);
    },
    [getDevSkills.fulfilled]: (state, action) => {
      state.pending = false;

      const result = action.payload.data.data;
      state.skills = result;
      //   state.skills = result.data;
      console.log(result);
    },
    [getDevSkills.rejected]: (state, action) => {
      state.pending = false;

      const result = action.payload.data.data;
      console.log(result);
    },
    [addDesvSkill.pending]: (state, action) => {
      state.pending = true;

      const result = action.payload;
      console.log(result);
    },
    [addDesvSkill.fulfilled]: (state, action) => {
      state.pending = false;

      const result = action.payload;
      console.log(result);
    },
    [addDesvSkill.rejected]: (state, action) => {
      state.pending = false;

      const result = action.payload;
      console.log(result);
    },
    [updateDevSkill.pending]: (state, action) => {
      state.pending = true;

      const result = action.payload;
      console.log(result);
    },
    [updateDevSkill.fulfilled]: (state, action) => {
      state.pending = false;

      const result = action.payload;
      console.log(result);
    },
    [updateDevSkill.rejected]: (state, action) => {
      state.pending = false;

      const result = action.payload;
      console.log(result);
    },
    [getDevSkill.pending]: (state, action) => {
      state.pending = true;

      const result = action.payload;
      console.log(result);
    },
    [getDevSkill.fulfilled]: (state, action) => {
      state.pending = false;

      const result = action.payload;
      state.skill = result;
      console.log(result);
    },
    [getDevSkill.rejected]: (state, action) => {
      state.pending = false;

      const result = action.payload;
      console.log(result);
    },
  },
});

export default skillSlice.reducer;
